<template>
  <div id="meet-our-team">
    <h3 class="f-s-24 l-h-153-p l-s-175 font-weight-bolder black-1 mb-5">
      Meet Our Core Team
    </h3>
    <b-row>
      <b-col
        v-for="(person, i) in teamPersonalInfo"
        :key="i"
        lg="4"
        md="6"
        sm="12"
      >
        <TeamMemberCard
          :key="i"
          :person="person"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import TeamMemberCard from '@/components/MeetOurTeam/TeamMemberCard';
import teamPersonalInfo from '@/constants/teamPersonalInfo';

export default {
  name: 'MeetOurTeam',
  components: { TeamMemberCard },
  data() {
    return {
      teamPersonalInfo,
    };
  },
};
</script>
